export default __webpack_public_path__ + "static/media/login.15ec7ac2.svg";